import { render, staticRenderFns } from "./UserSearchHeader.vue?vue&type=template&id=09a89179&scoped=true"
import script from "./UserSearchHeader.vue?vue&type=script&lang=ts"
export * from "./UserSearchHeader.vue?vue&type=script&lang=ts"
import style0 from "./UserSearchHeader.vue?vue&type=style&index=0&id=09a89179&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a89179",
  null
  
)

export default component.exports